import React, { MouseEvent, useState } from 'react'
import { useDispatch } from 'react-redux'
import Grid from '@mui/material/Grid'

import { Button, Paragraph, Popper } from 'components/shared'
import { ArchiveButton } from './ArchiveTask.style'

import { archiveTaskAction } from 'store/taskManager/actions'

interface IArchiveTask {
  taskId: number
  onClose: () => void
}

const ArchiveTask = (props: IArchiveTask) => {
  const { taskId, onClose } = props
  const dispatch = useDispatch()
  const [submitting, setSubmitting] = useState(false)
  const [archiveAnchorEl, setArchiveAnchorEl] = useState<HTMLElement | null>(null)
  const [archiveClicked, setArchiveClicked] = useState(false)

  const onArchiveEnter = (event: MouseEvent<HTMLElement>) => {
    setArchiveAnchorEl(event.currentTarget)
  }

  const archiveTask = () => {
    if (taskId) {
      setSubmitting(true)
      dispatch(
        archiveTaskAction({ id: taskId }, ({ success }) => {
          setSubmitting(false)
          if (success) onClose()
        })
      )
    }
  }
  return (
    <>
      <ArchiveButton
        onMouseEnter={onArchiveEnter}
        onMouseLeave={() => {
          if (!archiveClicked) {
            setArchiveAnchorEl(null)
          }
        }}
        onClick={() => setArchiveClicked(true)}
      >
        <svg width="16px" height="16px">
          <use xlinkHref="#archive" />
        </svg>
        <Paragraph size={'sm'}>Заархивировать задачу</Paragraph>
      </ArchiveButton>
      <Popper anchorEl={archiveAnchorEl} disablePortal={false} zIndex={10000}>
        <Paragraph style={{ marginBottom: 16 }} size={'sm'}>
          Вы действительно хотите переместить задачу в архив? После архивации задача пропадет из всех интерфейсов и
          вернуть ее можно только с помощью программистов.
        </Paragraph>
        {archiveClicked && (
          <Grid container spacing={1}>
            <Grid item>
              <Button size={'sm'} themetype={'white'} onClick={archiveTask} $loading={submitting}>
                Заархивировать
              </Button>
            </Grid>
            <Grid item>
              <Button
                size={'sm'}
                $border
                onClick={() => {
                  setArchiveAnchorEl(null)
                  setArchiveClicked(false)
                }}
              >
                Отменить
              </Button>
            </Grid>
          </Grid>
        )}
      </Popper>
    </>
  )
}

export default ArchiveTask
